<section class="pv" [class.pv--fiscal]="appearance === 'fiscal'" aria-labelledby="pv-title" [attr.aria-busy]="busy || step === 'loading' ? 'true' : null" [ngSwitch]="step" data-test="pv">
    <!-- Cargando, estado fallido o sesión de soporte: la cabecera del paso 1 y su aviso. -->
    <ng-container *ngSwitchCase="'loading'">
        <ng-container *ngTemplateOutlet="header; context: { title: copy.verifyTitle, subtitle: copy.verifySubtitle }"></ng-container>
        <div class="pv__loading" data-test="pv-loading"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span></div>
    </ng-container>

    <ng-container *ngSwitchCase="'statusFailed'">
        <ng-container *ngTemplateOutlet="header; context: { title: copy.verifyTitle, subtitle: copy.verifySubtitle }"></ng-container>
        <p class="pv-notice" role="alert" data-test="pv-status-failed">{{ copy.statusFailed }}</p>
        <button type="button" class="pv__primary" (click)="retry()" [disabled]="busy" data-test="pv-retry">{{ copy.retry }}</button>
    </ng-container>

    <ng-container *ngSwitchCase="'support'">
        <ng-container *ngTemplateOutlet="header; context: { title: copy.verifyTitle, subtitle: copy.verifySubtitle }"></ng-container>
        <p class="pv-notice" role="alert" data-test="pv-support">{{ copy.supportForbidden }}</p>
    </ng-container>

    <!-- Paso 1: el número guardado y el canal (artboard Main). -->
    <ng-container *ngSwitchCase="'confirm'">
        <ng-container *ngTemplateOutlet="header; context: { title: copy.verifyTitle, subtitle: copy.verifySubtitle }"></ng-container>
        <ng-container *ngTemplateOutlet="noticeBlock"></ng-container>

        <div class="pv-current" data-test="pv-confirm">
            <div class="pv-current__number">
                <span class="pv-current__label">{{ copy.currentLabel }}</span>
                <span class="pv-current__value" data-test="pv-display">{{ status?.display }}</span>
            </div>
            <button type="button" class="pv__link pv__link--not-mine" (click)="notMine()" [disabled]="busy" data-test="pv-not-mine">{{ copy.notMine }}</button>
        </div>

        <ng-container *ngTemplateOutlet="channels"></ng-container>

        <div class="pv__actions pv__actions--stack">
            <button type="button" class="pv__primary" (click)="sendCode()" [disabled]="!canSend" data-test="pv-send">
                {{ sendBlockedMs > 0 ? copy.resendIn(sendCountdown) : busy ? copy.sending : copy.send }}
            </button>
            <p class="pv__hint">{{ copy.sendHint }}</p>
        </div>
    </ng-container>

    <!-- Paso 1 (cambio): número nuevo, contraseña y canal (artboards CambiarNumero y NumeroInvalido). -->
    <ng-container *ngSwitchCase="'change'">
        <div *ngIf="invalidRaw" class="pv-warn" role="status" data-test="pv-invalid-notice">
            <svg
                class="pv-warn__icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
                <path d="M12 9v4M12 17h.01" />
            </svg>
            <span *ngIf="copy.invalidNotice(invalidRaw) as n"
                >{{ n.before }}<strong class="pv__num">{{ n.value }}</strong
                >{{ n.after }}</span
            >
        </div>

        <ng-container
            *ngTemplateOutlet="header; context: { title: isInvalidEntry ? copy.invalidTitle : copy.changeTitle, subtitle: isInvalidEntry ? copy.invalidSubtitle : copy.changeSubtitle }"
        ></ng-container>
        <ng-container *ngTemplateOutlet="noticeBlock"></ng-container>

        <form class="pv-change" (ngSubmit)="submitChange()" novalidate data-test="pv-change">
            <div class="pv-change__fields">
                <label class="pv-field">
                    {{ copy.phoneLabel }}
                    <input
                        class="pv-field__input pv__num ph-no-capture"
                        name="pvPhone"
                        type="tel"
                        inputmode="numeric"
                        autocomplete="tel-national"
                        [class.pv-field__input--error]="!!phoneError"
                        [attr.aria-invalid]="phoneError ? 'true' : null"
                        [attr.aria-describedby]="phoneError ? 'pv-phone-error' : 'pv-phone-hint'"
                        [placeholder]="copy.phonePlaceholder"
                        [ngModel]="phoneInput"
                        (ngModelChange)="onPhoneInput($event)"
                        data-test="pv-phone"
                    />
                    <small *ngIf="phoneError; else phoneHint" id="pv-phone-error" class="pv-field__error" role="alert" data-test="pv-phone-error">{{ phoneError }}</small>
                    <ng-template #phoneHint
                        ><small id="pv-phone-hint" class="pv-field__hint">{{ copy.phoneHint }}</small></ng-template
                    >
                </label>
                <label class="pv-field">
                    {{ copy.passwordLabel }}
                    <span class="pv-password">
                        <input
                            class="pv-field__input pv-password__input ph-no-capture"
                            name="pvPassword"
                            autocomplete="current-password"
                            [type]="showPassword ? 'text' : 'password'"
                            [class.pv-field__input--error]="!!passwordError"
                            [attr.aria-invalid]="passwordError ? 'true' : null"
                            [attr.aria-describedby]="passwordError ? 'pv-password-error' : null"
                            [placeholder]="copy.passwordPlaceholder"
                            [ngModel]="password"
                            (ngModelChange)="onPasswordInput($event)"
                            data-test="pv-password"
                        />
                        <button
                            type="button"
                            class="pv-password__toggle"
                            [attr.aria-label]="showPassword ? copy.hidePassword : copy.showPassword"
                            [attr.aria-pressed]="showPassword"
                            (click)="showPassword = !showPassword"
                            data-test="pv-show-password"
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                <circle cx="12" cy="12" r="3" />
                            </svg>
                        </button>
                    </span>
                    <small *ngIf="passwordError" id="pv-password-error" class="pv-field__error" role="alert" data-test="pv-password-error">{{ passwordError }}</small>
                </label>
            </div>

            <ng-container *ngTemplateOutlet="channels"></ng-container>

            <div *ngIf="!isInvalidEntry && status?.display" class="pv-note" data-test="pv-change-note">
                <svg
                    class="pv-note__icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 16v-4M12 8h.01" />
                </svg>
                <span *ngIf="copy.changeNote(status?.display || '') as n"
                    >{{ n.before }}<strong class="pv__num">{{ n.value }}</strong
                    >{{ n.after }}</span
                >
            </div>

            <div class="pv__actions">
                <button type="submit" class="pv__primary" [disabled]="!canSubmitChange" data-test="pv-change-submit">
                    {{ sendBlockedMs > 0 ? copy.resendIn(sendCountdown) : busy ? copy.sending : copy.send }}
                </button>
                <button *ngIf="canCancelChange" type="button" class="pv__link" (click)="cancelChange()" [disabled]="busy" data-test="pv-cancel">{{ copy.cancel }}</button>
            </div>
        </form>
    </ng-container>

    <!-- Paso 1 (código): 6 casillas, reenvío y «Verificar» (artboards Codigo y CodigoError). -->
    <ng-container *ngSwitchCase="'code'">
        <div class="pv-head">
            <span class="pv-head__icon"><ng-container *ngTemplateOutlet="channelIcon; context: { channel: sent?.channel, size: 22 }"></ng-container></span>
            <div class="pv-head__text">
                <span class="pv-head__eyebrow">{{ copy.stepLabel }}</span>
                <h2 id="pv-title" class="pv-head__title">{{ copy.codeTitle }}</h2>
                <p *ngIf="codeSubtitle as s" class="pv-head__subtitle" data-test="pv-code-subtitle">
                    {{ s.before }}<strong class="pv-head__strong pv__num">{{ s.value }}</strong
                    >{{ s.after }}
                </p>
            </div>
        </div>
        <ng-container *ngTemplateOutlet="noticeBlock"></ng-container>

        <fieldset class="pv-code" data-test="pv-code">
            <legend class="pv-code__legend">{{ copy.codeLegend }}</legend>
            <fina-phone-code-input
                [disabled]="busy || needsNewCode"
                [invalid]="codeInvalid"
                [describedBy]="codeError ? 'pv-code-error' : null"
                (changed)="onCodeChanged($event)"
                (completed)="onCodeCompleted($event)"
            ></fina-phone-code-input>
            <p *ngIf="codeError" id="pv-code-error" class="pv-code__error" role="alert" data-test="pv-code-error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 8v4M12 16h.01" />
                </svg>
                {{ codeError }}
            </p>
        </fieldset>

        <div class="pv-resend" data-test="pv-resend-row">
            <span>{{ copy.notReceived }}</span>
            <ng-container *ngIf="canResend || busy; else countdown">
                <button type="button" class="pv__link" (click)="resend(channel)" [disabled]="!canResend" data-test="pv-resend">{{ copy.resendBy(channelLabel(channel)) }}</button>
            </ng-container>
            <ng-template #countdown>
                <button type="button" class="pv__link" disabled data-test="pv-resend-countdown">{{ copy.resendIn(resendCountdown) }}</button>
            </ng-template>
            <button type="button" class="pv__link" (click)="resend(otherChannel)" [disabled]="!canResend" data-test="pv-send-other">{{ copy.sendByOther(channelLabel(otherChannel)) }}</button>
        </div>

        <div class="pv__actions">
            <button type="button" class="pv__primary" (click)="verifyCode()" [disabled]="!canVerify" data-test="pv-verify">{{ busy ? copy.verifying : copy.verify }}</button>
            <button type="button" class="pv__link pv__link--not-mine" (click)="notMine()" [disabled]="busy" data-test="pv-not-mine">{{ copy.notMine }}</button>
        </div>
        <p class="pv__hint pv__hint--tight" data-test="pv-code-hint">{{ codeHint === 'attempts' ? copy.codeAttemptsHint : copy.codeExpiryHint }}</p>
    </ng-container>
</section>

<!-- Cabecera de los pasos: ícono, «Paso 1 de 2», título y subtítulo. -->
<ng-template #header let-title="title" let-subtitle="subtitle">
    <div class="pv-head">
        <span class="pv-head__icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="6" y="2" width="12" height="20" rx="2.5" />
                <path d="M11 18h2" />
            </svg>
        </span>
        <div class="pv-head__text">
            <span class="pv-head__eyebrow">{{ copy.stepLabel }}</span>
            <h2 id="pv-title" class="pv-head__title">{{ title }}</h2>
            <p class="pv-head__subtitle">{{ subtitle }}</p>
        </div>
    </div>
</ng-template>

<ng-template #noticeBlock>
    <p *ngIf="notice" class="pv-notice" role="alert" data-test="pv-notice">{{ notice }}</p>
</ng-template>

<!-- SMS / WhatsApp: radios con la pista de cada canal. -->
<ng-template #channels>
    <fieldset class="pv-channels">
        <legend class="pv-channels__legend">{{ copy.channelLegend }}</legend>
        <div class="pv-channels__grid" role="radiogroup" [attr.aria-label]="copy.channelLegend">
            <button
                *ngFor="let c of channelOptions"
                type="button"
                role="radio"
                class="pv-channel"
                [attr.aria-checked]="channel === c"
                [disabled]="isChannelDisabled(c)"
                (click)="selectChannel(c)"
                [attr.data-test]="'pv-channel-' + c"
            >
                <span class="pv-channel__icon"><ng-container *ngTemplateOutlet="channelIcon; context: { channel: c, size: 18 }"></ng-container></span>
                <span class="pv-channel__text">
                    <span class="pv-channel__name">{{ channelLabel(c) }}</span>
                    <span class="pv-channel__hint">{{ channelHint(c) }}</span>
                </span>
            </button>
        </div>
    </fieldset>
</ng-template>

<ng-template #channelIcon let-channel="channel" let-size="size">
    <svg
        *ngIf="channel === 'sms'"
        [attr.width]="size"
        [attr.height]="size"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
    <svg
        *ngIf="channel !== 'sms'"
        [attr.width]="size"
        [attr.height]="size"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8z" />
    </svg>
</ng-template>
